import Model    from "./Model";
import Country  from "./Country";

export default class City extends Model
{
    constructor( options = {} )
    {
        super('/api/v1/geo/cities');

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id            = options.id                   || null;
        this.name          = options.name                 || null;
        this.name          = options.name                 || null;
        this.name_en       = options.name_en              || null;
        this.name_es       = options.name_es              || null;
        this.name_pt       = options.name_pt              || null;
        this.name_it       = options.name_it              || null;
        this.name_fr       = options.name_fr              || null;
        this.name_de       = options.name_de              || null;
        this.permalink     = options.permalink            || null;
        this.country       = new Country( options.country || {} );
        this.permalinks    = options.permalinks           || [];
    }

    toJson ()
    {
        return {
            id          : this.id,
            name        : this.name,
            name_en     : this.name_en,
            name_es     : this.name_es,
            name_pt     : this.name_pt,
            name_it     : this.name_it,
            name_fr     : this.name_fr,
            name_de     : this.name_de,
            country     : this.country.toJson(),
            permalink   : this.permalink,
            permalinks  : this.permalinks,
        }
    }
//
    label() {
        return printf('%s, %s', this.name, this.country.name)
    }

    getName(lang = null){

        let name = null;

        switch (lang){
            case 'en': name = this.name_en; break;
            case 'es': name = this.name_es; break;
            case 'pt': name = this.name_pt; break;
            case 'it': name = this.name_it; break;
            case 'fr': name = this.name_fr; break;
            case 'de': name = this.name_de; break;
            default:   name = this.name;
        }

        return name;
    }
}


// WEBPACK FOOTER //
// ./resources/js/models/City.js